import {Catalog} from 'react-planner';

let catalog = new Catalog();

const importAll = (r) => {
  let elements = {};
  r.keys().forEach((item) => {
    const element = r(item);
    console.log('Importing element:', element);
    elements[item.replace('./', '')] = element;
  });
  return elements;
};

const Areas = importAll(require.context('./areas', true, /planner-element\.jsx$/));
const Lines = importAll(require.context('./lines', true, /planner-element\.jsx$/));
const Holes = importAll(require.context('./holes', true, /planner-element\.jsx$/));
const Items = importAll(require.context('./items', true, /planner-element\.jsx$/));

for( let x in Areas ) {
    catalog.registerElement( Areas[x].default );
}
for( let x in Lines ) {
    catalog.registerElement( Lines[x].default );
}
for( let x in Holes ) {
    catalog.registerElement( Holes[x].default );
}
for( let x in Items ) {
    catalog.registerElement( Items[x].default );
}

let windowChildren = [];
let doorChildren = [];
for (let x in Holes) {
    if (x.toLowerCase().includes('window')) {
        windowChildren.push(Holes[x].default);
    } else if (x.toLowerCase().includes('door')) {
        doorChildren.push(Holes[x].default);
    }   
}
if (windowChildren.length > 0) {
    catalog.registerCategory('windows', 'Windows', windowChildren);
}
if (doorChildren.length > 0) {
    catalog.registerCategory('doors', 'Doors', doorChildren);
}

export default catalog;
